import { useEffect, useState } from "react";
import { getPostBySlug, WPPost } from "../content/contentClient";

type UseWPPostResult = {
  post: WPPost | null;
  loading: boolean;
  notFound: boolean;
};

export default function useWPPost(slug?: string, lang?: string): UseWPPostResult {
  const [post, setPost] = useState<WPPost | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    let active = true;

    const load = async () => {
      setLoading(true);
      setNotFound(false);
      try {
        const data = await getPostBySlug(slug, lang);
        if (!data) {
          if (active) {
            setNotFound(true);
            setPost(null);
          }
          return;
        }
        if (active) setPost(data);
      } catch {
        if (active) {
          setNotFound(true);
          setPost(null);
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [slug, lang]);

  return { post, loading, notFound };
}
